import type { ReactNode } from 'react';

import { PageDisclaimer } from '#/components/ui/PageDisclaimer';
import { cn } from '#/utils/cn';

interface HomepageLayoutProps {
  children: ReactNode;
  className?: string;
}

/**
 * Applies the homepage breakout grid. Children set their own col-* classes.
 *
 * Drawer open state is handled entirely in CSS via the [data-drawer-open]
 * attribute set by DefinitionDrawerProvider
 */
export function HomepageLayout({ children, className }: HomepageLayoutProps) {
  return (
    <main id="content" className={cn('grid-cols-layout grid', className)}>
      {children}

      <PageDisclaimer className="col-feature" />
    </main>
  );
}
